import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource } from "./BaseResource";
class ThemeResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.design = "";
        this.palettePrimaryMain = "";
        this.paletteSecondaryMain = "";
        this.paletteAccent1Main = "";
        this.paletteAccent2Main = "";
        this.paletteAccent3Main = "";
        this.paletteAccent4Main = "";
        this.paletteBackgroundDefault = "";
        this.paletteBackgroundDrawer = "";
        this.dashboardImageCropMode = "";
        this.formWebLogoDisabled = false;
    }
    pk() {
        return this.id?.toString();
    }
}
ThemeResource.automaticValidation = "silent";
ThemeResource.urlRoot = apiResourceUrl("themes");
export { ThemeResource };
//# sourceMappingURL=ThemeResource.js.map